module.exports = __webpack_public_path__ + "img/hr-heatex-E-idle.a4f98fe9.png";